import React, { FC, useEffect, useState } from "react";
import "./VerificationDocumentUploadCard.scss";
import { FileSignSvg } from "../../../../../../Components/Svg/FileSignSvg";
import { MessageSvg } from "../../../../../../Components/Svg/MessageSvg";
import { DeleteSvg } from "../../../../../../Components/Svg/deleteSvg";
import projectService from "../../../../../../Services/projectService";
import toast from "react-hot-toast";
import ConfirmToast from "../../../../../../Components/ConfirmToast/ConfirmToat";

type ActionType = "delete" | "replace";

interface propTypes {
  inputKey?: string | undefined;
  title: string;
  description: string;
  value?: any;
  changeHandler?: any;
  name: string;
  doc: string;
  checkIfExist: any;
  projectData?: any;
  removeImage?: any;
  images?: any;
  startUploading?: any;
  refreshProject?: () => void;
}

const VerificationDocumentUploadCard: FC<propTypes> = ({
  inputKey,
  title,
  description,
  value,
  changeHandler,
  name,
  doc,
  checkIfExist,
  projectData,
  removeImage,
  images,
  startUploading,
  refreshProject,
}) => {
  const [selectedImages, setSelectedImages] = useState<Array<File>>([]);

  const [currentAction, setCurrentAction] = useState<{
    type: ActionType;
    payload: { key: string };
  } | null>(null);

  useEffect(() => {
    setSelectedImages(images);
  }, [images]);

  // trigger
  const handleAction = (type: ActionType, payload: { key: string }) => {
    setCurrentAction({ type, payload });
    window.dispatchEvent(new Event(`show-${type}-toast`));
  };

  // confirm
  const handleDelete = async ({ key }: { key: string }) => {
    try {
      const res = await projectService.deleteFile(projectData.projectUuid, key);
      if (res.data.status === true) {
        toast.success("Image deleted successfully", {
          className: "custom-alert bg-white text-dark",
        });
        // handleClose();
      } else {
        toast.error("Failed to delete image");
      }
      refreshProject?.(); // using safe optional chaining here, incase the fxn returns undefined
    } catch (err: any) {
      console.error(err.response);
      if (err.response.data.error === "Image not found in project") {
        toast.error("Image already deleted, kindly reload the page", {
          className: "custom-alert bg-white text-dark",
        });
      } else {
        toast.error("An error occurred");
      }
    } finally {
      setCurrentAction(null);
    }
  };

  const handleReplace = async ({ key }: { key: string }) => {
    try {
      if (images.length > 0) {
        const resp = await projectService.deleteFile(
          projectData.projectUuid,
          key
        );

        if (resp.data.status === false) {
          toast.error(
            "Image already deleted, kindly reload the page if issue persist",
            {
              className: "custom-alert bg-white text-dark",
            }
          );
        }

        startUploading(projectData.projectUuid);
        toast.success("Image updated successfully", {
          className: "custom-alert bg-white text-dark",
        });
      } else {
        toast.error(
          "Please upload an image to replace the current selected one"
        );
      }

      refreshProject?.();
    } catch (err: any) {
      console.log("err", err);
      toast.error("An error occurred");
    } finally {
      setCurrentAction(null);
    }
  };

  // console.log("projectData_in_VeriCard", projectData);

  // custom jsx rendered dynamically
  const fileInputEl = (
    <input
      key={inputKey?.toString()}
      id={name}
      type="file"
      accept="image/*"
      className="form-control file-upload-input"
      onChange={(event) => {
        changeHandler(event, doc);
      }}
      multiple
      value={value}
      name={name}
    />
  );

  return (
    <React.Fragment>
      <div
        className={
          checkIfExist(doc)
            ? "VerificationDocumentUploadCard w-100  border-danger"
            : "VerificationDocumentUploadCard w-100"
        }
      >
        {selectedImages.length > 0 &&
          selectedImages.map((res: any, index) => (
            <div key={index} className="card file-upload-preview mb-1">
              <div className="card-body">
                <div className="row">
                  <div className="col-2 my-auto">
                    <MessageSvg />
                  </div>
                  <div className="col-8">
                    <div className="file-name">{res.file.name}</div>
                    <div className="row file-name mt-2">
                      <div className="col-4">
                        <div className="uploaded-size">{res.file.size}</div>
                      </div>
                      <div className="col-8 p-0">
                        <div className="uploaded-message">
                          Document Uploaded
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-2 my-auto">
                    <button
                      className="btn p-1 border-0"
                      type="button"
                      onClick={() => removeImage(Number(index))}
                    >
                      <DeleteSvg />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}

        {/* image list with delete */}
        <div className="row">
          {projectData?.images?.map((image: any, idx: number) => (
            <div className="col-6 col-md-4 col-lg-6 mb-3" key={idx}>
              <img
                crossOrigin="anonymous"
                src={image.url}
                className="img-fluid rounded img-fit"
                alt={`image-${idx + 1}`}
              />
              <div className="mt-2 d-flex gap-2">
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() =>
                    handleAction("delete", { key: image.keyFromCloudProvider })
                  }
                >
                  Delete
                </button>
                <button
                  className="btn btn-confirm-toast btn-sm"
                  onClick={() =>
                    handleAction("replace", { key: image.keyFromCloudProvider })
                  }
                >
                  Replace
                </button>
              </div>
            </div>
          ))}
        </div>

        <ConfirmToast
          actionType="delete"
          message="Are you sure you want to delete this image ?"
          onConfirm={handleDelete}
          onCancel={() => setCurrentAction(null)}
          payload={
            currentAction?.type === "delete" ? currentAction.payload : null
          }
        />

        <ConfirmToast
          actionType="replace"
          message="Do you want to replace this image with a new one ?"
          onConfirm={handleReplace}
          onCancel={() => setCurrentAction(null)}
          payload={
            currentAction?.type === "replace" ? currentAction.payload : null
          }
          customContent={fileInputEl}
        />

        <div className="title">{title}</div>
        {/* {!file && ( */}
        <div className="verificationDocumentUploadCardInner mt-4">
          <label className="mb-3 file-upload" htmlFor={name}>
            <FileSignSvg />
            {fileInputEl}
          </label>
          <div className="document-desc">
            Drag and drop, or browse your files
          </div>
        </div>
        {/* )} */}
      </div>
    </React.Fragment>
  );
};

export default VerificationDocumentUploadCard;
